export const USER_ROLES = {
  ROLE_USER: 'ROLE_USER',
  ROLE_BUSINESS: 'ROLE_BUSINESS',
  ROLE_BUSINESS_STC: 'ROLE_BUSINESS_STC',
  ROLE_IC_OPERATOR: 'ROLE_IC_OPERATOR'
};
